import { render, staticRenderFns } from "./Skills.vue?vue&type=template&id=6452d1ec&lang=pug&"
import script from "./Skills.vue?vue&type=script&lang=ts&"
export * from "./Skills.vue?vue&type=script&lang=ts&"
import style0 from "./Skills.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Skills.vue"
export default component.exports